import SubjectForm from '../components/SubjectForm';
import useNewSubjectHelpAndSupport from './useNewSubjectHelpAndSupport';

export default function NewSubjectHelpAndSupport() {
    const { handleSubmit } = useNewSubjectHelpAndSupport();

    return (
        <SubjectForm action='Adicionar' onSubmit={handleSubmit} />
    )
}
